import React from "react";
import Flx from "../../../components/layout/Flx";
import PublicFormGrid from "../../../components/publicForm/PublicFormGrid";
import DisclosureBox from "../../../components/publicForm/DisclosureBox";
import PublicFormSection from "../../../components/publicForm/PublicFormSection";
import RffFileUploadField from "../../../components/finalForm/inputs/RffFileUploadField";
import RffSignatureField from "../../../components/finalForm/inputs/RffSignatureField";
import { AGREEMENT_PARAGRAPHS } from "../applicationFormShared";

/** Final step — supporting files, the authorization agreement, and signature. */
const StepConfirmation = () => (
  <Flx column>
    <PublicFormSection
      title="Supporting Documents"
      description="Optional. Purchase contracts, rent rolls, scopes of work, or anything else that supports the application."
    >
      <PublicFormGrid>
        <RffFileUploadField label="Additional File Uploads" />
      </PublicFormGrid>
    </PublicFormSection>

    <PublicFormSection title="Disclosure &amp; Signature">
      <Flx column gap={3}>
        <DisclosureBox
          title="Authorization Agreement."
          paragraphs={AGREEMENT_PARAGRAPHS}
        />
        <PublicFormGrid>
          <RffSignatureField
            required
            name="signature"
            label="Signature"
            helperText="By signing, you agree to the authorization agreement above."
          />
        </PublicFormGrid>
      </Flx>
    </PublicFormSection>
  </Flx>
);

export default StepConfirmation;
